import React, { useEffect } from "react";
import "./advance.scss";
import { useHistory } from "react-router-dom";
import Axios from "axios";

function Advance() {
    const history=useHistory();
    return (
        <div className="Advance_main">
            <h1>Advance Features</h1>
            <div className="advance_inner" style={{rowGap:"20px"}}>
                <div className="feature_block" onClick={()=>history.push("/logs")}>
                    <p>Logs</p>
                </div>
                <div className="feature_block" onClick={()=>history.push("/PendingPackages")}>
                    <p>Archived packages</p>
                </div>
                <div className="feature_block" onClick={()=>history.push("/DeliveryInfos")}>
                    <p>Delivery Information</p>
                </div>
                <div className="feature_block" onClick={()=>history.push("/statuses")}>
                    <p>Package Status</p>
                </div>
                <div className="feature_block" onClick={()=>history.push("/financialReport")}>
                    <p>Financial Report</p>
                </div>
                <div className="feature_block" onClick={()=>history.push("/updatePackage")}>
                    <p>Package Update</p>
                </div>
            </div>
        </div>
    );
}

export default Advance;
